import { FC, useState } from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

import { PEARL } from '../../Helpers/colors';

const Accordion = styled((props: AccordionProps) => <MuiAccordion disableGutters elevation={0} square {...props} />)(
	() => ({
		'&:not(:last-child)': {
			borderBottom: 0,
		},
		'&:before': {
			display: 'none',
		},
	}),
);

const AccordionSummary = styled((props: AccordionSummaryProps) => (
	<MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
))(({ color }) => ({
	backgroundColor: 'rgba(0, 0, 0, .03)',
	padding: '16px',
	minHeight: 'unset !important',
	borderRadius: '0',
	'& .MuiAccordionSummary-expandIconWrapper': {
		color,
		marginRight: '0px',
	},
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		margin: '0 !important',
	},
	'&.Mui-expanded': {
		minHeight: 'unset !important',
		borderBottom: '1px solid rgba(0, 0, 0, .08)',
	},
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
	padding: '0',
	borderTop: 'none',
	outline: 'none',
}));

interface AccordionProperties {
	Content: FC;
	HeaderContent: FC;
	accordionClassName?: string;
	accordionDetailsClassName?: string;
	backgroundColor?: string;
	className?: string;
	color?: string;
	defaultExpanded?: boolean;
	headerStyle?: object;
}

// TODO: Solve the case having 3 different classes properties for the accordion
const CustomAccordion: FC<AccordionProperties> = ({
	Content,
	HeaderContent,
	backgroundColor = 'transparent',
	color = PEARL.BASE[900],
	className = '',
	headerStyle = {},
	defaultExpanded = false,
	accordionClassName = '',
	accordionDetailsClassName = '',
}) => {
	const [expanded, setExpanded] = useState<boolean>(defaultExpanded);

	return (
		<div className={className}>
			<Accordion expanded={expanded} onChange={() => setExpanded(!expanded)} className={accordionClassName}>
				<AccordionSummary color={color} style={{ backgroundColor, ...headerStyle }}>
					<HeaderContent />
				</AccordionSummary>
				<AccordionDetails className={accordionDetailsClassName}>{expanded && <Content />}</AccordionDetails>
			</Accordion>
		</div>
	);
};

export default CustomAccordion;
